import injectSheet from 'react-jss'
import Notifications from './Notifications'
import styles from './Notifications.styles'

export default injectSheet(styles)(Notifications)
